<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    ผู้ใช้งานระบบ
                </div>



                <div class="row search-section" style="margin-top:15px;">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="addUser()">
                            <i class="material-icons">add_box</i>
                            <span>สร้างผู้ใช้งานระบบ</span>
                        </button>

                    </div>
                    <div class="col-sm-5 col-search"></div>
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" placeholder="กรุณากรอกชื่อ เพื่อค้นหา"
                            style="width:100%;margin-top:5px">
                    </div>
                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-1 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>
                </div>


                <div class="body table-responsive" style="width:100%">
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th">Username</th>
                                    <th class="fn-th">ชื่อ</th>
                                    <th class="fn-th">สิทธิ</th>
                                    <th class="fn-th">วันที่สร้าง</th>
                                    <th class="fn-th">วันที่แก้ไข</th>
                                    <th class="fn-th">แก้ไข</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.user_id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <!-- <td v-html="((page-1) * perpage) + index + 1"></td> -->
                                    <td style="text-align: center;">

                                        <span>{{ item.username }}</span>

                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.name }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.role_name }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.create_datetime | date }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.update_datetime | date }}</span>
                                    </td>

                                    <td>
                                        <span v-if="userStorage.id == 1 && item.user_id == 1"
                                            @click="editUser(item.user_id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                        <span v-if="item.user_id > 1" @click="editUser(item.user_id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.user_id > 1" @click="deleteUser(item.user_id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        <div class="modal fade" id="user-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างUser</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">
                    <div class="row">
                        <div class="col-sm-2  col-label">
                            <span>Username</span>
                        </div>
                        <div class="col-sm-10">
                            <div style="float: left;margin-top: 5px;" v-if="user.user_id > 0">{{ user.username }}</div>
                            <input type="text" class="form-control" v-model="user.username" placeholder="" v-else>

                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ชื่อ</span>
                        </div>
                        <div class="col-sm-10">
                            <div style="float: left;margin-top: 5px;" v-if="user.username == 'admin'">{{ user.name }}
                            </div>
                            <input type="text" v-model="user.name" class="form-control " placeholder="" v-else>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;" v-if="user.user_id > 0">
                        <div class="col-sm-2  col-label">

                        </div>
                        <div class="col-sm-10" style="text-align: left;">
                            <input type="checkbox" id="checkbox-user" @click="setpassword = !setpassword"
                                class="filled-in chk-col-indigo" :checked="setpassword" />
                            <label for="checkbox-user">ตั้งค่ารหัสผ่านใหม่</label>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>รหัสผ่าน</span>
                        </div>
                        <div class="col-sm-10">
                            <input type="password" v-model="user.password" class="form-control " placeholder=""
                                :disabled="!setpassword">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ยืนยันรหัสผ่าน</span>
                        </div>
                        <div class="col-sm-10">
                            <input type="password" v-model="user.confirm_password" class="form-control " placeholder=""
                                :disabled="!setpassword">
                        </div>
                    </div>

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>สิทธิ</span>
                        </div>
                        <div class="col-sm-6">
                            <div style="float: left;margin-top: 5px;" v-if="user.username == 'admin'">Administrator
                            </div>
                            <select class="form-control show-tick" v-model="user.role_id" v-else>
                                <option value="1">Administrator</option>
                                <option value="2">Staff</option>
                                <option value="3">User</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { UserService } from '../../service'
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "ManageUser",
    components: {
        Paginate
    },
    data() {
        return {
            userStorage: JSON.parse(localStorage.getItem('user')),
            page: 1,
            perpage: 50,
            total: 0,
            pages: 0,
            block_set: 5,
            block_index: 0,
            blocks: [],
            items: [],
            key: "",
            user: {
                user_id: 0,
                role_id: 0,
                username: "",
                name: "",
                password: "",
                confirm_password: "",
                rolename: "",
                create_datetime: "",
                update_datetime: ""
            },
            setpassword: false,
            searching: false,
            loading: false
        }
    },
    async created() {
        this.search(1)
    },
    mounted() {

    },
    methods: {
        async search(p = 0) {
             if (p > 0) {
                this.page = p
            }
            this.loading = true
            this.search_param = {
                searchKey: this.key,
                page: p,
                perpage: this.perpage
            }
            let response = await UserService.search(this.search_param)

            if (response.status) {
                let { page, perpage, total, pages, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data

            }
            this.loading = false
        },
        reset(p = 1) {
            this.key = ""
            this.search(p)
        },
        addUser() {
            this.user = {
                user_id: 0,
                role_id: 0,
                username: "",
                name: "",
                password: "",
                confirm_password: "",
                create_datetime: "",
                update_datetime: "",
                active: "1"
            },
                this.setpassword = true
            $('#user-modal').modal('show')
        },
        editUser(id) {
            this.user = this.items.find(x => x.user_id == id)
            this.setpassword = false
            $('#user-modal').modal('show')
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            if (this.user.user_id == 0) {
                if (this.checkPassword()) {
                    await this.create()
                }
            }
            else {
                if (this.user.password) {
                    if (this.checkPassword()) {
                        await this.update()
                    }
                }
                else {
                    await this.update()
                }

            }


        },
        validate() {
            if (!this.user.username) {
                alertBox.error("กรุณากรอก username")
                return false
            }
            if (!this.user.name) {
                alertBox.error("กรุณากรอกชื่อ")
                return false
            }
            if (!this.user.role_id) {
                alertBox.error("กรุณาเลือกสิทธิ")
                return false
            }
            return true
        },
        checkPassword() {
            if (!this.user.password) {
                alertBox.error("กรุณากรอกรหัสผ่าน")
                return false
            }
            if (!this.user.confirm_password) {
                alertBox.error("กรุณากรอกยืนยันรหัสผ่าน")
                return false
            }
            if (this.user.password !== this.user.confirm_password) {
                alertBox.error("รหัสผ่านกับยืนยันรหัสผ่านไม่ตรงกัน")
                return false
            }
            if (this.user.password.length < 8) {
                alertBox.error("กรุณากรอกรหัสผ่านไม่น้อยกว่า 8 ตัวอักษร")
                return false
            }
            return true

        },
        async create() {
            try {
             
                let response = await UserService.create(this.user)

                if (response.status) {
                    alertBox.success('save success')
                    $('#user-modal').modal('hide')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async update() {
            try {
                let response = await UserService.update(this.user)
                if (response.status) {
                    alertBox.success('save success')
                    $('#user-modal').modal('hide')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async deleteUser(user_id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')

            if (result) {
                let response = await UserService.delete(user_id)

                if (response.status) {
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }

        }
    },
    filters: {
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/Manage/User.vue